'use client';

import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import PeakContainerBadge from '../Container/Peak';
import PlusContainerBadge from '../Container/Plus';
import { ContainerBadgeProps } from '../Container/types';
import PeakLogoBadge from '../Logo/Peak';
import PlusLogoBadge from '../Logo/Plus';
import { SubscriptionBadgeBadgeProps } from '../Logo/types';
import usePaidFeatureBadgeTier from './usePaidFeatureBadgeTier';

type LogoProps = { featureTier: PurchaseTier; badgeStyle?: 'logo' } & SubscriptionBadgeBadgeProps;
type ContainerProps = { featureTier: PurchaseTier; badgeStyle: 'container' } & ContainerBadgeProps;

type PaidFeatureBadgeProps = LogoProps | ContainerProps;

const PaidFeatureBadge = (props: PaidFeatureBadgeProps) => {
  const tier = usePaidFeatureBadgeTier(props.featureTier);

  if (props.badgeStyle === 'container') {
    const { className, size } = props;
    return tier === 'peak' ? <PeakContainerBadge className={className} size={size} /> : <PlusContainerBadge className={className} size={size} />;
  }

  const { className, size, variant, textColor } = props;
  return tier === 'peak' ? (
    <PeakLogoBadge className={className} size={size} variant={variant} textColor={textColor} />
  ) : (
    <PlusLogoBadge className={className} size={size} variant={variant} textColor={textColor} />
  );
};

export default PaidFeatureBadge;
